<template>
    <div class="movie-box">

        <div v-if="isless">
            <ul class="movie-box acea-row row-between row-middle" :style="boxStyle">
                <li class="nav-title" :style="liStyle" v-for="(item, ind) in navList" :key="ind" @click="changeNav(item)">
                    <img class="page-image" :src="checked == item.id ? item.checkImg : item.img" />
                </li>
            </ul>
        </div>
        
        <div v-else>
            <ul class="movie-horizontal-scroll-bar" ref="navBar" :style="boxStyle">
                <li class="page-inline-block nav-title" :style="liStyle" v-for="(item, ind) in navList" :key="ind" :ref="'nav'+item.id" @click="changeScrollNav(item)">
                    <img class="page-image" :src="checked == item.id ? item.checkImg : item.img" />
                </li>
            </ul>
        </div>


    </div>
</template>

<script>
export default {
    name: "FestivalNav",
    props: {
        isless: {
            type: Boolean,
            default: true
        },
        current: {
            type: Number,
            default: ""
        },
        navList: {
            type: Array,
            default: ()=>[]
        },
        boxStyle: {
            type: Object,
            default: ()=>{}
        },
        liStyle: {
            type: Object,
            default: ()=>{}
        }
    },
    watch: {
        current: function (newVal) {
            if (newVal == this.checked) return;
            this.checked = newVal;
            if (!this.isless) {
                this.scrollToFn(newVal);
            }
        }
    },
    data: function () {
        return {
            checked: "",
            scrollNavList: []
        }
    },
    mounted: function () {
        if (!this.isless) {
            this.getNavDom();
        }
    },
    methods: {
        changeNav: function (val) {
            this.checked = val.id;
            this.$emit("checkNav", val.id);
        },
        changeScrollNav: function (val) {
            this.checked = val.id;
            this.scrollToFn(val.id);
            this.$emit("checkNav", val.id);
        },
        scrollToFn: function (Id) {
            let dom = this.$refs.navBar;
            this.scrollNavList.forEach((item)=>{
                if (item.id == Id) {
                    dom.scrollTo(item.left, 0);
                }
            })
        },
        getNavDom: function () {
            const clientWidth = this.$refs.navBar.clientWidth/2;
            let arr = this.navList;
            arr.forEach((item) => {
                let dom = this.$refs[`nav${item.id}`][0];
                item.left = dom.offsetLeft-clientWidth+(dom.offsetWidth/2);
            });
            this.scrollNavList = arr;
        }
    }
}
</script>

<style scoped>
.nav-title {
    width: 1.7rem;
    margin: 0 .08rem;
}
</style>